/**
 * Types of created items
 */
export enum SelectInputCreateTypeEnum {
    EMAIL = "EMAIL"
}